<tc-setup-grid
        #setupGrid
        [readOnly]="false"
        [colDefConfig]="colDefConfig"
        [setupGridComp]="this"
        [dataSource]="this"
        [actionColumnWidth]="65">
</tc-setup-grid>
